// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__5cMoD","new":"Tag_new__zOts4","hit":"Tag_hit__E7e4Y","pre_order":"Tag_pre_order__RNaZt"};